<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <input type="text" v-model="params.user" v-width="130" placeholder="用户"
               @keyup.enter="doSearch">
      </Cell>
      <Cell>
        <input type="text" v-model="params.module" v-width="130" placeholder="模块"
               @keyup.enter="doSearch">
      </Cell>
      <Cell>
        <div class="h-input-group" v-width="320">
          <DatePicker v-model="params.start" style="width: 130px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 130px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button icon="fa fa-refresh" @click="loadList">刷新</Button>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="logList" :border="true" :loading="loading">
        <TableItem title="#" type="number" :width="50"></TableItem>
        <TableItem title="创建时间" prop="createTime" :width="160"></TableItem>
        <TableItem title="用户" prop="username" :width="110"></TableItem>
        <TableItem title="模块" prop="module" :width="110"></TableItem>
        <TableItem title="操作" prop="operation" :width="130"></TableItem>
        <TableItem title="请求方法" prop="method" :width="90" align="center"></TableItem>
        <TableItem title="请求路径" prop="url"></TableItem>
        <TableItem title="IP" prop="ip" :width="130"></TableItem>
        <TableItem title="耗时(ms)" prop="costTime" :width="90" align="right"></TableItem>
        <TableItem title="成功" :width="80" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="data.success === false ? 'h-tag-bg-red' : 'h-tag-bg-green'">
              {{ data.success === false ? '失败' : '成功' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="90">
          <div class="actions" slot-scope="{data}">
            <span @click="viewDetail(data)">查看详情</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <!--日志详情弹窗-->
    <Modal v-model="showDetail" hasCloseIcon :middle="true" width="640">
      <div slot="header">日志详情</div>
      <div class="detail-wrap">
        <p><b>用户：</b>{{ detail.username }}（{{ detail.ip }}）</p>
        <p><b>请求：</b>{{ detail.method }} {{ detail.url }}</p>
        <p><b>时间：</b>{{ detail.createTime }}，耗时 {{ detail.costTime }}ms</p>
        <p><b>请求参数(args)：</b></p>
        <pre class="detail-args">{{ argsText }}</pre>
      </div>
      <div class="text-center">
        <Button color="green" @click="showDetail=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AuditLog',
  data() {
    return {
      logList: [],
      params: {
        user: '',
        module: '',
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      showDetail: false,
      detail: {},
      loading: false
    }
  },
  computed: {
    argsText() {
      let args = this.detail.args;
      if (!args && args !== 0) {
        return '无';
      }
      if (typeof args === 'string') {
        try {
          return JSON.stringify(JSON.parse(args), null, 2);
        } catch (e) {
          return args;
        }
      }
      try {
        return JSON.stringify(args, null, 2);
      } catch (e) {
        return String(args);
      }
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$api.audit.list(Object.assign({}, this.params, {
        page: this.pagination.page,
        size: this.pagination.size
      })).then(({data}) => {
        this.logList = data.results || data.records || data || [];
        this.pagination.total = data.total || 0;
      }).catch(() => {
        this.$Message.error('审计日志加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    viewDetail(data) {
      this.detail = data;
      this.showDetail = true;
    },
    doExport() {
      //导出当前筛选条件下的全部日志（后端上限 50000 条），而非仅当前页
      const qs = Object.keys(this.params)
        .filter(k => this.params[k] !== '' && this.params[k] !== null && this.params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(this.params[k]))
        .join('&');
      window.open('/api/audit-log/export' + (qs ? '?' + qs : ''), '_blank');
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.detail-wrap {
  font-size: 13px;
  line-height: 24px;
}

.detail-args {
  background: #f5f5f5;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  padding: 10px;
  max-height: 300px;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
